module.exports = __webpack_public_path__ + "static/media/web_open.587c24ff.ico";